var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHosLogoCrop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 37,
    viewBox: "0 0 43 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_832_34167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9781 26.3607H7.12784C7.12784 26.3607 -0.371157 13.0746 10.4038 0.824219C10.4038 0.824219 5.4499 16.702 15.9781 26.3607Z",
    fill: "#58A84A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1483 26.3607C17.1483 26.3607 6.16887 18.8419 11.9288 0.824219C11.9288 0.824219 20.4501 24.1548 42.7685 26.3607H28.8492C28.8492 26.3607 20.1234 24.2411 15.2894 15.8618C15.2894 15.8618 15.5291 22.4718 21.5288 26.3607H17.1483Z",
    fill: "#FDE700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.768555 27.8711H7.84924C7.84924 27.8711 10.2886 31.8031 8.08894 36.8139C8.08894 36.8139 7.72939 31.369 0.768555 27.8711Z",
    fill: "#58A84A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.64844 27.8711C8.64844 27.8711 11.2076 30.8943 9.00799 36.8139C9.00799 36.8139 16.1568 34.4456 16.5281 27.8711H8.64844Z",
    fill: "#FDE700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4492 27.8711C17.4492 27.8711 17.8088 31.8869 12.5894 35.9509C12.5894 35.9509 19.4491 33.2728 20.9297 27.8711H17.4492Z",
    fill: "#58A84A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_832_34167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 35.9922,
    fill: "white",
    transform: "translate(0.768555 0.824219)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHosLogoCrop);
export default __webpack_public_path__ + "static/media/HOS-logo-crop.bd0ab8e6c31868aa292176b25b65c9dc.svg";
export { ForwardRef as ReactComponent };